import { render, staticRenderFns } from "./Two.vue?vue&type=template&id=fbf0e038&"
import script from "./Two.vue?vue&type=script&lang=js&"
export * from "./Two.vue?vue&type=script&lang=js&"
import style0 from "./Two.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports